<template>
  <div class="support-ticket-content-w">
    <div class="support-ticket-content">
      <div class="element-wrapper">
        <div class="element-box">
          <div class="form-header">
            <div class="os-tabs-controls os-tabs-complex">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a class="nav-link active show"
                    ><span v-if="data.vehiculo_obj">{{
                      data.vehiculo_obj.placa
                    }}</span></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link active show"
                    ><span v-if="data.vehiculo">{{
                      data.vehiculo_obj.marca_obj.nombre
                    }}</span></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link active show"
                    ><span v-if="data.vehiculo">{{
                      data.vehiculo_obj.linea_obj.nombre
                    }}</span></a
                  >
                </li>
                <li style="background-color: #88ff6e" class="nav-item">
                  <a class="nav-link active show"
                    ><span>Total: Q{{ data.total }}</span></a
                  >
                </li>
              </ul>
            </div>
            <div class="form-control">
              <div class="os-tabs-w"></div>
              Orden de Servicio #
              <span class="badge text-success">{{ data.id }}</span>
              <br />
              Creo Pedido:
              <span class="badge text-success">{{
                data.usuario_recibe_obj.name
              }}</span>
              <br />
              Propietario:
              <span v-if="data.propietario" class="badge text-success">{{
                data.propietario
              }}</span>
              <br />
              <div v-if="data.estado == 'A'" class="badge badge-success">
                {{ data.estado_str }}
              </div>
              <div v-if="data.estado == 'C'" class="badge badge-dark">
                {{ data.estado_str }}
              </div>
              <div v-if="data.estado == '9'" class="badge badge-danger">
                {{ data.estado_str }}
              </div>
              <br />
              <br />
              <h6>
                <router-link :to="{ name: 'talleres-home', params: {} }">
                  <i class="os-icon os-icon-arrow-left5 text-dark">Regresar</i>
                </router-link>
                <div style="float: right" class="btn-group">
                  <button
                    style="float: right"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i class="fa fa-cogs"></i>
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button
                      class="dropdown-item"
                      @click="anular(data)"
                      :disabled="!(data.estado != '9')"
                      href="#"
                    >
                      <i class="fas fa-file-excel"></i>
                      Anular Operación
                    </button>
                    <button
                      class="dropdown-item"
                      @click="finalizarOrden(data)"
                      :disabled="!(data.estado != '9')"
                      href="#"
                    >
                      <i class="fas fa-clipboard-check"></i>
                      Finalizar la orden
                    </button>
                    <div class="dropdown-divider"></div>
                  </div>
                </div>
              </h6>
            </div>
          </div>
          <h5 class="text-success">Detalle de la orden de servicios</h5>
          <div class="row mt-2">
            <div class="col-lg-12">
              <div class="padded-lg">
                <!--START - Projects list-->
                <div class="projects-list">
                  <div
                    class="project-box"
                    v-for="detalle in data.ordenserviciodetalle_set"
                    :key="detalle.id"
                    @click="modalModificarDetalle(detalle)"
                  >
                    <div
                      class="project-head"
                      style="padding-rigth: 1em; padding-left: 1em"
                    >
                      <div class="project-title">
                        <h6>{{ detalle.tipo_servicio_obj.nombre }}</h6>
                        <span
                          >{{ detalle.producto }} -
                          {{ detalle.descripcion }}</span
                        >
                        <br />
                        Responsable:
                        <span
                          v-if="detalle.usuario_realiza_obj"
                          class="text-success"
                          >{{ detalle.usuario_realiza_obj.name }}</span
                        >
                      </div>
                      <br />
                      <br />
                    </div>
                    <div class="project-info">
                      <div class="row">
                        <div class="col-sm-12 text-center">
                          <div class="row">
                            <div class="col-4">
                              <div class="el-tablo highlight">
                                <div class="label">Cantidad</div>
                                <h6 style="color: green">
                                  {{ detalle.cantidad }}
                                </h6>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="el-tablo highlight">
                                <div class="label">Precio</div>
                                <h6 style="color: green">
                                  {{ detalle.precio }}
                                </h6>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="el-tablo highlight">
                                <div class="label">Total</div>
                                <h6 style="color: green">
                                  {{ detalle.total }}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--END - Projects list-->
              </div>
            </div>
            <ModalPedidoOrdenComponent
              @refreshDetalle="refreshDetalle"
              :datos="data"
            />
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        class="onboarding-modal modal"
        id="modificarDetalle"
        role="dialog"
        tabindex="-1"
      >
        <div class="modal-dialog modal-centered" role="document">
          <div class="modal-content text-center">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span class="close-label">Cancelar</span>
              <span class="os-icon os-icon-close"></span>
            </button>
            <div class="onboarding">
              <div class="onboarding-content with-gradient">
                <h4 class="onboarding-title text-center">
                  Modificar o eliminar detalle
                </h4>
                <div v-if="currentDetalle" class="text-center"></div>
                <div class="row">
                  <button
                    class="btn btn-block btn-md btn-danger"
                    type="button"
                    @click="eliminarDetalle()"
                  >
                    Eliminar Linea
                  </button>
                </div>
                <br />
                <h6 class="text-center font-weight-bold">
                  {{ currentDetalle.producto }} -
                  {{ currentDetalle.descripcion }}
                </h6>
                <div class="col-12">
                  <label>Cantidad</label>
                  <input
                    type="text"
                    v-model="currentDetalle.cantidad"
                    class="form-control"
                    placeholder="Cantidad"
                  />
                </div>
                <div class="col-sm-12">
                  <UsuariosDeServiciosSelectComponent
                    titulo="Responsable de servicio"
                    :current="currentDetalle"
                  />
                </div>
                {{ currentDetalle.tipo }}
                <br />
                <button
                  class="btn btn-block btn-md btn-dark"
                  type="button"
                  @click="modificarDetalle(currentDetalle)"
                >
                  Modificar detalle
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import ModalPedidoOrdenComponent from "@/components/talleres/ModalPedidoOrdenComponent";
import DynamicService from "@/services/commons/DynamicService";
import UsuariosDeServiciosSelectComponent from "@/components/commons/UsuariosDeServiciosSelectComponent";

export default {
  components: {
    ModalPedidoOrdenComponent,
    UsuariosDeServiciosSelectComponent,
  },
  props: {
    current: {
      type: Object,
    },
  },
  data() {
    return {
      currentDetalle: {
        usuario: "",
      },
      data: {
        current: {
          producto: "",
        },
        usuario_realiza_obj: "",
        usuario_recibe_obj: "",
      },
    };
  },
  mounted() {
    let self = this;
    self.refreshDetalle();
  },
  methods: {
    modificarDetalle(currentDetalle) {
      let self = this;
      if (currentDetalle.usuario) {
        currentDetalle.usuario_realiza = currentDetalle.usuario.id;
      }
      DynamicService.postAction(
        "taller",
        "orden-servicio",
        self.data.id,
        "modificar_linea",
        currentDetalle
      ).then((response) => {
        Notifications.alert.success(
          "Modificar detalle",
          "Realizado correctamente"
        );
        $("#modificarDetalle").modal("hide");
        self.refreshDetalle();
      });
    },
    finalizarOrden(data) {
      let self = this;
      Notifications.alert.confirm(
        "Finalizar orden de servicio",
        "¿Esta seguro de finalizar la orden?",
        "",
        function () {
          DynamicService.postAction(
            "taller",
            "orden-servicio",
            data.id,
            "finalizar",
            data.id
          )
            .then((response) => {
              Notifications.alert.success(
                "Finalizar orden servicio",
                "¡Realizado correctamente!"
              );
              self.$router.push({
                name: "talleres-home",
                params: {},
              });
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular(data) {
      let self = this;
      Notifications.alert.confirm(
        "Orden Servicio",
        "¿Esta seguro de anular la orden?",
        "",
        function () {
          DynamicService.postAction(
            "taller",
            "orden-servicio",
            data.id,
            "anular",
            data
          )
            .then((response) => {
              Notifications.alert.success(
                "Orden de servicio",
                "Anulado correctamente"
              );
              self.$router.push({
                name: "talleres-home",
                params: {},
              });
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar(data) {
      let self = this;
      Notifications.alert.confirm(
        "Orden Servicio",
        "¿Esta seguro de cerrar la orden?",
        "",
        function () {
          DynamicService.postAction(
            "taller",
            "orden-servicio",
            data.id,
            "cerrar",
            data
          )
            .then((response) => {
              Notifications.alert.success(
                "Orden de servicio",
                "Cerrado correctamente"
              );
              self.refreshDetalle();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    abrir(data) {
      let self = this;
      Notifications.alert.confirm(
        "Orden Servicio",
        "¿Esta seguro de abrir la orden?",
        "",
        function () {
          DynamicService.postAction(
            "taller",
            "orden-servicio",
            data.id,
            "abrir",
            data
          )
            .then((response) => {
              Notifications.alert.success(
                "Orden de servicio",
                "Abierto correctamente"
              );
              self.refreshDetalle();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    eliminarDetalle() {
      let self = this;
      console.log(self.currentDetalle);
      DynamicService.postAction(
        "taller",
        "orden-servicio",
        self.data.id,
        "eliminar_detalle",
        {
          id: self.currentDetalle.id,
        }
      )
        .then((response) => {
          Notifications.alert.success(
            "Detalle de orden servicio",
            "Eliminado Correctamente"
          );
          $("#modificarDetalle").modal("hide");
          self.refreshDetalle();
        })
        .catch((error) => {
          Notifications.alert.error(
            "Eliminar Liniea",
            error.response.data.detail
          );
        });
    },
    modalModificarDetalle(detalle) {
      let self = this;
      if (self.data.estado == "A") {
        self.currentDetalle = detalle;
        self.currentDetalle.estado = "A";
        self.currentDetalle.usuario = detalle.usuario_realiza_obj;
        $("#modificarDetalle").modal();
      }
    },
    refreshDetalle() {
      let self = this;
      DynamicService.getById(
        "taller",
        "orden-servicio",
        this.$route.params.id
      ).then((res) => {
        self.data = res.data;
      });
    },
  },
};
</script>
